import React from 'react'
import {Icon} from '@chakra-ui/react'

const CloseIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" cursor="pointer" {...props}>
            <path
                d="M28 11.9999L12 27.9999"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 11.9999L28 27.9999"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default CloseIcon
